import { render, staticRenderFns } from "./StoresSingle.vue?vue&type=template&id=57bb74ef"
import script from "./StoresSingle.vue?vue&type=script&lang=js"
export * from "./StoresSingle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../website-admin/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports